import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { fetchManufacturers } from 'b2b-apps/shop/manufacturer/redux/manufacturers/actionCreators';
import { getManufacturers } from 'b2b-apps/shop/manufacturer/redux/manufacturers/selectors';
import { ManufacturersType } from 'b2b-apps/shop/manufacturer/redux/manufacturers/types';

type UseManufacturersEffectReturnType = RemoteRecord<ManufacturersType>;

const useManufacturersEffect = (
  query?: string,
  filter?: string,
): UseManufacturersEffectReturnType => {
  const dispatch = useDispatch();
  const manufacturers = useSelector(getManufacturers);

  useEffect(
    (): void => {
      dispatch(fetchManufacturers(query, filter));
    },
    [
      dispatch,
      filter,
      query,
    ],
  );

  return manufacturers;
};

export type { UseManufacturersEffectReturnType };
export { useManufacturersEffect };
